export const localizeText = (map: { [language: string]: string } | null | undefined): string => {
  return map?.nl ?? "";
};
